import { Box, Typography, Hidden, Tooltip } from '@material-ui/core';
import { Backdrop, Switch } from '@room-match/shared-ui-components';
import { MainProfileDetailsProps } from 'pages/MyLinks/types';
import { FC, useMemo, useState } from 'react';
import { useQueryClient } from 'react-query';
import { talentService } from 'shared/services/talentService';
const { updateMe } = talentService();

const MainProfileDetails: FC<MainProfileDetailsProps> = ({
  stage_name,
  preferences,
  changeActiveLink,
  agencyActivated,
}) => {
  const queryClient = useQueryClient();
  const { mutate: updateMutate, isLoading } = updateMe();
  const [checked, setChecked] = useState(preferences?.public_link_active || false);
  const savePreferences = useMemo(() => preferences, [preferences]);
  const FONT_SIZE = 20;

  const onSuccessAddition = async () => {
    setChecked((prev) => !prev);
    changeActiveLink();
    await queryClient.invalidateQueries(['me']);
  };

  const handlePublicProfileClick = () => {
    if (savePreferences) {
      updateMutate(
        {
          preferences: {
            ...savePreferences,
            public_link_active: !checked,
          },
        },
        {
          onSuccess: async () => {
            await onSuccessAddition();
          },
        },
      );
    } else {
      updateMutate(
        {
          preferences: {
            theme: 'dark', // Since preferences is null, default of theme is dark
            public_link_active: !checked, // This will be true once the talent click the toggle, by default its false if savePreferences is null or undefined
          },
        },
        {
          onSuccess: async () => {
            await onSuccessAddition();
          },
        },
      );
    }
  };

  return (
    <Box style={{ marginTop: '5px' }}>
      <Backdrop isLoading={isLoading} />
      <Hidden smDown>
        <Typography style={{ textAlign: 'start', fontSize: FONT_SIZE, wordBreak: 'break-word' }}>
          {stage_name}
        </Typography>
      </Hidden>
      <Hidden mdUp>
        <Typography style={{ textAlign: 'center', fontSize: FONT_SIZE, wordBreak: 'break-word' }}>
          {stage_name}
        </Typography>
      </Hidden>
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <Box display={'flex'} alignItems={'center'} style={{ marginLeft: '-15px' }}>
          <Tooltip
            title={'Your agent has activated this on your behalf. This option is now disabled.'}
            disableHoverListener={!agencyActivated}
          >
            <div>
              <Switch checked={checked} disabled={agencyActivated || isLoading} toggle={handlePublicProfileClick} />
            </div>
          </Tooltip>
          <Typography style={{ fontSize: 12, opacity: checked ? 1 : 0.2 }}>Activate my Public Profile</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MainProfileDetails;
